import { Injectable } from "@angular/core";
import { Observable, merge, BehaviorSubject } from "rxjs";
import {
	Router,
	RouterEvent,
	NavigationError,
	NavigationStart,
	NavigationEnd,
	ResolveStart,
	GuardsCheckEnd,
	Event,
} from "@angular/router";
import { filter, map, delay } from "rxjs/operators";

@Injectable({
	providedIn: "root",
})
export class LoadingProgressBarService {
	loading$: Observable<any>;
	private manualProgressSubj: BehaviorSubject<number> = new BehaviorSubject(null);
	private awaitManualStop: boolean = false;

	constructor(private router: Router) {
		const routerEvents = this.router.events.pipe(
			filter(
				(
					event: Event | RouterEvent
				): event is
					| NavigationStart
					| NavigationEnd
					| ResolveStart
					| NavigationError
					| GuardsCheckEnd => this.filterRouterEvents(event)
			),
			map(this.mapEventToProgress)
		);
		this.loading$ = merge(routerEvents, this.manualProgressSubj.asObservable()).pipe(delay(0));
	}

	filterRouterEvents(
		event: RouterEvent | Event
	): event is NavigationStart | NavigationEnd | ResolveStart | NavigationError | GuardsCheckEnd {
		return (
			event instanceof NavigationStart ||
			event instanceof NavigationEnd ||
			event instanceof ResolveStart ||
			event instanceof NavigationError ||
			(event instanceof GuardsCheckEnd && !event.shouldActivate)
		);
	}

	mapEventToProgress(event: RouterEvent): { progress: number } {
		return event instanceof NavigationStart
			? { progress: 0 }
			: event instanceof ResolveStart
			? { progress: 100 }
			: null;
	}

	clearProgress(): void {
		this.manualProgressSubj.next(null);
	}

	setProgress(num: number): void {
		this.manualProgressSubj.next(num);
	}
}
